var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"temp-page"},[_c('van-loading',{attrs:{"type":"circular","color":"#999"}}),_c('p',{staticClass:"status-message"},[_vm._v(_vm._s(_vm.statusMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }